// src/pages/UserAgreement.js
import React from "react";
import SEO from "../components/SEO";

const UserAgreement = () => {
  return (
    <>
      <SEO
        title="End-User License Agreement (EULA) | Oolook"
        description="Read the legally binding End-User License Agreement governing your use of Oolook’s software, including our web platform, mini-tools, APIs, and mobile applications."
        noIndex={false}
      />
      <main className="relative isolate bg-dark-bg px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <article className="prose prose-invert lg:prose-lg prose-headings:font-bold prose-a:text-dark-accent-start hover:prose-a:text-dark-accent-end">
            <h1>End-User License Agreement ("EULA")</h1>
            <p className="lead">Last Updated and Effective Date: 24 April 2025</p>

            <h2>1. Acceptance of Agreement</h2>
            <p>
              This EULA is a legally binding agreement between you ("Licensee" or "you") and Oolook Ltd. ("Licensor" or "we"). By installing, copying, or otherwise using the Oolook software, which includes the web platform, mini-tools, APIs, and mobile applications (collectively, the "Software"), you agree to be bound by the terms of this EULA, our <a href="/terms">Terms of Service</a>, and our <a href="/privacy">Privacy Policy</a>. If you do not agree, do not use the Software.
            </p>

            <h2>2. License Grant</h2>
            <p>
              Subject to your strict compliance with this EULA, Licensor grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Software for your personal or internal business purposes, strictly in accordance with the features and documentation associated with your chosen subscription plan.
            </p>

            <h2>3. License Restrictions</h2>
            <p>You agree that you will not, and will not permit any third party to:</p>
            <ul>
              <li>Reverse engineer, decompile, disassemble, or otherwise attempt to discover the source code or underlying algorithms of the Software or our AI models.</li>
              <li>Modify, adapt, or create derivative works based on the Software.</li>
              <li>Sell, rent, lease, sublicense, distribute, or otherwise transfer rights to the Software.</li>
              <li>Remove or obscure any proprietary notices on the Software.</li>
              <li>Use the Software for any purpose other than its intended purpose, including for any illicit, fraudulent, or harmful activities.</li>
              <li>Use the Software to develop a competing product or service.</li>
            </ul>

            <h2>4. Intellectual Property & Ownership</h2>
            <p>
              You acknowledge that the Software is licensed, not sold. Oolook retains all right, title, and interest in and to the Software, including all copyrights, patents, trade secrets, and other intellectual property rights. We reserve all rights not expressly granted to you in this EULA.
            </p>
            
            <h2>5. Generated Content</h2>
            <p>
              Subject to your compliance with these terms and payment of any applicable fees, Oolook grants you ownership of the specific AI-generated outputs ("Generated Content") you create using the Services. However, you acknowledge that similar or identical content may be generated for other users from similar prompts. We retain all rights to the underlying AI models and algorithms.
            </p>

            <h2>6. Telemetry and Data Collection</h2>
            <p>
              You acknowledge and agree that the Software may automatically transmit anonymous usage data, performance metrics, and crash reports to Oolook's servers. This data is used to improve the stability, security, and functionality of the Software and is handled in accordance with our Privacy Policy.
            </p>

            <h2>7. Termination</h2>
            <p>
              This EULA is effective until terminated. Your rights under this license will terminate automatically without notice from us if you fail to comply with any term(s) of this EULA. Upon termination, you shall cease all use of the Software and destroy all copies, full or partial, of the Software.
            </p>

            <h2>8. Disclaimer of Warranty</h2>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS," WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND. LICENSOR DOES NOT WARRANT THAT THE FUNCTIONS CONTAINED IN THE SOFTWARE WILL MEET YOUR REQUIREMENTS OR THAT THE OPERATION OF THE SOFTWARE WILL BE UNINTERRUPTED OR ERROR-FREE.
            </p>
            
            <h2>9. Contact Information</h2>
            <p>
              For any questions concerning this EULA, please contact us at <a href="mailto:legal@oolook.in">legal@oolook.in</a>.
            </p>
          </article>
        </div>
      </main>
    </>
  );
};

export default UserAgreement;